var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var Pill = /** @class */ (function (_super) {
    __extends(Pill, _super);
    function Pill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.measureRef = function (element) {
            var passWidth = _this.props.passWidth;
            if (element) {
                _this.elementRef = element;
                passWidth(Math.round(element.getBoundingClientRect().width));
            }
        };
        return _this;
    }
    Pill.prototype.render = function () {
        var _a = this.props, nursery = _a.nursery, clearNurserySearch = _a.clearNurserySearch;
        return (React.createElement("div", { ref: this.measureRef, className: "search__pill nursery" },
            React.createElement("span", null, "Nursery | "),
            nursery,
            React.createElement("span", { className: "x-btn", onClick: clearNurserySearch, role: "button", "aria-label": "x", tabIndex: 0, onKeyDown: clearNurserySearch })));
    };
    return Pill;
}(React.Component));
export default Pill;
